import clsx from 'clsx';
import { useDndContext, useDraggable, useDroppable } from '@dnd-kit/core';
import { useDropdownMenu } from '../../../../shared/hooks';
import { CAMPAIGN_CADENCES_TYPE_TAB_KEY } from '../../constants/campaignCadencesTabs';
import { slotDroppableId } from '../../lib/cadenceSlotId';
import { CampaignCadenceCardPanel } from './CampaignCadenceCardPanel';
import { TemplateWarnings } from './TemplateWarnings';
import styles from './CampaignCadenceCard.module.css';

export function CampaignCadenceStepSlot({
  item,
  language,
  stepIndex,
  stepNumber,
  totalSteps,
  isEditing,
  onMoveToStep,
  onPreview,
  onEdit,
}) {
  const droppableId = slotDroppableId(stepIndex, language);
  const {
    rootRef: moveToRef,
    open: moveToOpen,
    toggleOpen: handleMoveToToggle,
    close: closeMoveTo,
  } = useDropdownMenu();

  const { setNodeRef: setDropRef, isOver } = useDroppable({
    id: droppableId,
    disabled: !isEditing,
  });

  // A slot only lights up for a drag it would actually accept, which means the same language.
  const { active } = useDndContext();
  const dragged = active?.data?.current ?? null;
  const isDropTarget = isOver && dragged?.language === language;

  const {
    attributes,
    listeners,
    setNodeRef: setDragRef,
    isDragging,
  } = useDraggable({
    id: item ? item.id : `${droppableId}-empty`,
    data: { stepIndex, language },
    disabled: !isEditing || !item,
  });

  const handleMoveToStep = (targetStep) => {
    closeMoveTo();
    onMoveToStep?.(targetStep);
  };

  return (
    <div className={clsx(styles.languageColumn)}>
      <div ref={setDropRef} className={clsx(styles.slotDropArea)}>
        {item ? (
          <CampaignCadenceCardPanel
            template={item.template}
            variant={CAMPAIGN_CADENCES_TYPE_TAB_KEY.MARKETING}
            showLanguageFlag
            isEditing={isEditing}
            appearance={isDragging ? 'placeholder' : isDropTarget ? 'dropTarget' : 'default'}
            panelRef={setDragRef}
            gripAttributes={attributes}
            gripListeners={listeners}
            stepNumber={stepNumber}
            totalSteps={totalSteps}
            moveToRef={moveToRef}
            moveToOpen={moveToOpen}
            onMoveToToggle={handleMoveToToggle}
            onMoveToStep={handleMoveToStep}
            onPreview={onPreview ? () => onPreview(item.template) : undefined}
            onEdit={onEdit ? () => onEdit(item.template) : undefined}
          />
        ) : (
          <div className={clsx(styles.emptyPanel, isDropTarget && styles.emptyPanelOver)} />
        )}
      </div>
      {!isEditing && item && <TemplateWarnings warnings={item.template.warnings ?? []} />}
    </div>
  );
}
